import { Route } from "react-router";
import { Dashboard } from "views";
import uuid from "react-uuid";
import { getComponentWithLoading, CRM_API } from "utils";

//Compania Config y Permisos
import ConfigurarCompania from "views/ConfigurarCompania";
import PerfilEdit from "views/PerfilEdit";
import PerfilList from "views/PerfilList";

//Usuarios y Equipos
import UsuarioList from "views/UsuarioList";
import UsuarioEdit from "views/UsuarioEdit";
import UsuariosEquipos from "views/UsuariosEquipos";

//Entidades
import { Example } from "views";
import CargaMasivaECFList from "views/CargaMasivaECF/CargaMasivaECFList";
import CargaMasivaECF from "views/CargaMasivaECF/CargaMasivaECF";
import TransaccionesList from "views/Transacciones/TransaccionesList";
import TransaccionesEdit from "views/Transacciones/TransaccionesEdit";
import AnulacionesList from "views/Anulacion/AnulacionesList";
import AnulacionEdit from "views/Anulacion/AnulacionEdit";
import ComprobantesRecibidosList from "views/ComprobantesRecibidos/ComprobantesRecibidosList";
import FirmarArchivoXML from "views/FirmarArchivo/FirmarArchivoXML";
import AprobacionComercialList from "views/AprobacionComercial/AprobacionComercialList";
import AprobacionComercialEdit from "views/AprobacionComercial/AprobacionComercialEdit";
import CompaniaList from "views/Admin/CompaniaList";
import CompaniaEdit from "views/Admin/CompaniaEdit";
import SolicitudCompaniaTenantList from "views/Admin/SolicitudCompaniaTenantList";
import Reporte from "views/Reporte/Reporte";
import RequestLogList from "views/Admin/RequestLogList";
import ConfigurarEmailCompania from "./components/Email/ConfigurarEmailCompania";
import SerieFiscalList from "views/SerieFiscalList";
import SerieFiscalEdit from "views/SerieFiscalEdit";
import VincularQuickbooks from "views/Quickbooks/VincularQuickbooks";

import ItemList from "views/Item/ItemList";
import ItemEdit from "views/Item/ItemEdit";
import ProcesoList from "views/Proceso/ProcesoList";
import ProcesoEdit from "views/Proceso/ProcesoEdit";
import CategoriaList from "views/Categoria/CategoriaList";

import CompaniaVinculadaList from "views/Tenant/CompaniaVinculadaList";
import CompaniaVinculadaEdit from "views/Tenant/CompaniaVinculadaEdit";
import CargaMasivaPage from "views/CargaMasiva/CargaMasivaPage";
import TerceroList from "views/Tercero/TerceroList";
import TerceroEdit from "views/Tercero/TerceroEdit";
import CredencialesCertificacion from "views/CredencialesCertificacion/CredencialesCertificacion";
import TransaccionesRecurrentesList from "views/TransaccionesRecurrentes/TransaccionesRecurrentesList";
import TransaccionesRecurrentesEdit from "views/TransaccionesRecurrentes/TransaccionesRecurrentesEdit";


export const routes = [
  <Route
    exact
    path={"/Reporte"}
    key={uuid()}
    component={getComponentWithLoading(Reporte)}
  />,
  <Route
    exact
    path={"/CargaMasivaECFList"}
    key={uuid()}
    component={getComponentWithLoading(CargaMasivaECFList)}
  />,
  <Route
    exact
    path={"/CargaMasivaECF"}
    key={uuid()}
    component={getComponentWithLoading(CargaMasivaECF)}
  />,
  <Route
    exact
    path={"/TransaccionesList"}
    key={uuid()}
    component={getComponentWithLoading(TransaccionesList)}
  />,
  <Route
    exact
    path={"/TransaccionesEdit"}
    key={uuid()}
    component={getComponentWithLoading(TransaccionesEdit)}
  />,
  <Route
    exact
    path={"/CompaniaVinculadaList"}
    key={uuid()}
    component={getComponentWithLoading(CompaniaVinculadaList)}
  />,
  <Route
    exact
    path={"/AnulacionesList"}
    key={uuid()}
    component={getComponentWithLoading(AnulacionesList)}
  />,
  <Route
    exact
    path={"/AnulacionesEdit"}
    key={uuid()}
    component={getComponentWithLoading(AnulacionEdit)}
  />,
  <Route
    exact
    path={"/AprobacionComercialList"}
    key={uuid()}
    component={getComponentWithLoading(AprobacionComercialList)}
  />,
  <Route
    exact
    path={"/AprobacionComercialEdit"}
    key={uuid()}
    component={getComponentWithLoading(AprobacionComercialEdit)}
  />,
  <Route
    exact
    path={"/ComprobantesRecibidosList"}
    key={uuid()}
    component={getComponentWithLoading(ComprobantesRecibidosList)}
  />,
  <Route
    exact
    path={"/FirmarArchivoXML"}
    key={uuid()}
    component={getComponentWithLoading(FirmarArchivoXML)}
  />,
  <Route
    exact
    path={"/ConfigurarCompania"}
    key={uuid()}
    component={getComponentWithLoading(ConfigurarCompania)}
  />,
  <Route
    exact
    path={"/SolicitudCompaniaTenantList"}
    key={uuid()}
    component={getComponentWithLoading(SolicitudCompaniaTenantList)}
  />,
  <Route
    exact
    path={"/UsuariosEquipos"}
    key={uuid()}
    component={getComponentWithLoading(UsuariosEquipos)}
  />,
  <Route
    exact
    path={"/UsuarioList"}
    key={uuid()}
    component={getComponentWithLoading(UsuarioList)}
  />,
  <Route
    exact
    path={"/UsuarioEdit"}
    key={uuid()}
    component={getComponentWithLoading(UsuarioEdit)}
  />,
  <Route
    exact
    path={"/PerfilEdit"}
    key={uuid()}
    component={getComponentWithLoading(PerfilEdit)}
  />,
  <Route
    exact
    path={"/PerfilList"}
    key={uuid()}
    component={getComponentWithLoading(PerfilList)}
  />,
  <Route
    exact
    path={"/CompaniaList"}
    key={uuid()}
    component={getComponentWithLoading(CompaniaList)}
  />,

  <Route
    exact
    path={"/CompaniaEdit"}
    key={uuid()}
    component={getComponentWithLoading(CompaniaEdit)}
  />,

  <Route
    exact
    path={"/CompaniaVinculadaEdit"}
    key={uuid()}
    component={getComponentWithLoading(CompaniaVinculadaEdit)}
  />,

  <Route
    exact
    path={"/RequestLogList"}
    key={uuid()}
    component={getComponentWithLoading(RequestLogList)}
  />,
  <Route
    exact
    path={"/SerieFiscalList"}
    key={uuid()}
    component={getComponentWithLoading(SerieFiscalList)}
  />,

  <Route
    exact
    path={"/SerieFiscalEdit"}
    key={uuid()}
    component={getComponentWithLoading(SerieFiscalEdit)}
  />,
  <Route
    exact
    path={"/CategoriaList"}
    key={uuid()}
    component={getComponentWithLoading(CategoriaList)}
  />,
  <Route
    exact
    path={"/ItemList"}
    key={uuid()}
    component={getComponentWithLoading(ItemList)}
  />,

  <Route
    exact
    path={"/ItemEdit"}
    key={uuid()}
    component={getComponentWithLoading(ItemEdit)}
  />,

  <Route
    exact
    path={"/ProcesoList"}
    key={uuid()}
    component={getComponentWithLoading(ProcesoList)}
  />,
  <Route
    exact
    path={"/ProcesoEdit"}
    key={uuid()}
    component={getComponentWithLoading(ProcesoEdit)}
  />,

  <Route
    path={"/ConfiguracionEmail"}
    key={"/ConfiguracionEmail"}
    component={getComponentWithLoading(ConfigurarEmailCompania)}
  ></Route>,

  <Route
    exact
    path={"/CargaMasiva"}
    key={uuid()}
    component={getComponentWithLoading(CargaMasivaPage)}
  />,

  <Route
    exact
    path={"/Example"}
    key={uuid()}
    component={getComponentWithLoading(Example)}
  />,

  <Route
    exact
    path={"/vincularQuickbooks"}
    key={uuid()}
    component={getComponentWithLoading(VincularQuickbooks)}
  />,

  <Route
    exact
    path={"/TerceroList"}
    key={uuid()}
    component={getComponentWithLoading(TerceroList)}
  />,
  <Route
    exact
    path={"/TerceroEdit"}
    key={uuid()}
    component={getComponentWithLoading(TerceroEdit)}
  />,
  <Route
    exact
    path={"/CredencialesCertificacion"}
    key={uuid()}
    component={getComponentWithLoading(CredencialesCertificacion)}
  />,
  <Route
    exact
    path={"/TransaccionesRecurrentesList"}
    key={uuid()}
    component={getComponentWithLoading(TransaccionesRecurrentesList)}
  />,
  <Route
    exact
    path={"/TransaccionesRecurrentesEdit"}
    key={uuid()}
    component={getComponentWithLoading(TransaccionesRecurrentesEdit)}
  />,


  
  <Route
    path="/Public/Temp/*"
    component={(props) => {
      var rootUrl = "";
      var urlParts = (CRM_API || "").split("/api");
      if (urlParts.length > 1) {
        rootUrl = urlParts[0];
      } else {
        rootUrl = window.location.origin;
      }
      var reportUrl = `${rootUrl}${props.history.location.pathname}`;
      window.location.href = reportUrl;
      return null;
    }}
  />,

  /////////////////////////////////////////////////////////
  <Route exact path={"/Dashboard"} key={uuid()} component={Dashboard} />,

  //////////////////Mantener siempre al final/////////////////////
  <Route
    path={"/"}
    key={uuid()}
    component={getComponentWithLoading(Dashboard)}
  ></Route>,
  /////////////////////////////////////////////////////////
];
